export interface Product {
  id: string;
  name: string;
  brand?: string;
  description: string;
  image: string;
  price: string;
  purchaseOptions: string | ProductOptionValues[];
  boxWeight: string;
  productType: string;
  specialPrices?: string;
  hasStock?: boolean;
}

export type ProductPayload = Omit<Product, 'id'>;

export interface ProductOption {
  value: ProductOptionValues;
  label: string;
}

export enum ProductOptionValues {
  HALF_CRATE = 'half_crate',
  FULL_CRATE = 'full_crate',
  UNIT = 'unit',
  KG = 'kg',
  GR = 'gr',
  LT = 'lt',
  PACK = 'pack',
  MAPLE = 'maple',
}

export enum ProductType {
  FRUIT = 'fruta',
  VEGETABLE = 'verdura',
  CONDIMENTS = 'condimentos',
  DRIED = 'secos',
  OTHERS = 'otros',
}

export const productTypeOptions = [
  { value: ProductType.FRUIT, label: 'Fruta' },
  { value: ProductType.VEGETABLE, label: 'Verdura' },
  { value: ProductType.CONDIMENTS, label: 'Condimentos' },
  { value: ProductType.DRIED, label: 'Secos' },
  { value: ProductType.OTHERS, label: 'Otros' },
];

// Las opciones de compra se definen usando el enum 'ProductOptionValues'
export const purchaseOptions = [
  { value: ProductOptionValues.FULL_CRATE, label: 'Cajon entero' },
  { value: ProductOptionValues.HALF_CRATE, label: '1/2 Cajon' },
  { value: ProductOptionValues.UNIT, label: 'Unidad' },
  { value: ProductOptionValues.KG, label: 'Kg' },
  { value: ProductOptionValues.GR, label: 'Gr' },
  { value: ProductOptionValues.LT, label: 'Litros' },
  { value: ProductOptionValues.PACK, label: 'Paquete' },
  { value: ProductOptionValues.MAPLE, label: 'Maple' },
];

export const getOptionLabel = (value: ProductOptionValues) => {
  const option = purchaseOptions.find((opt) => opt.value === value);
  return option ? option.label : value;
};
